export default "__VITE_ASSET__eb247d1c__"